import { store } from '@wajeez-web/stores/base';
import { handleDispatchResult } from '@wajeez-web/core/utils';
import { Server } from '@wajeez-web/core/api-base';

import {
  actions,
  getContentDetailsByIdMultilingualAsync,
  getContentItemDetailsByIdMultilingualAsync,
  createContentEntityMultilingualAsync,
  editContentEntityMultilingualAsync,
  setExpectedPublishDateAsync,
  getContentEntityBadgeAsync,
  setContentEntityBadgeAsync,
  getOnboardingRandomContentEntitiesAsync,
  getOnboardingContentEntityDetailsByIdAsync,
  getContentEntitySEOByIdAsync,
  upsertContentEntitySEOAsync,
  changeContentEntityArchiveStatusAsync,
} from './slices';
import {
  SetContentEntityBadgeInput,
  GetOnboardingRandomContentEntitiesInput,
} from './types';

export const getContentEntityDetailsByIdMultilingual = async (
  id: string | undefined,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getContentDetailsByIdMultilingualAsync(id));

  return handleDispatchResult(res, onSuccess);
};

export const getContentEntityItemDetailsByIdMultilingual = async (
  id: string | undefined,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    getContentItemDetailsByIdMultilingualAsync(id)
  );

  return handleDispatchResult(res, onSuccess);
};

export const createContentEntityMultilingual = async (
  data: Server.CreateContentEntityByTypeIdV2Input,
  onSuccess?: (response: string) => void | Promise<void>
) => {
  const res = await store.dispatch(createContentEntityMultilingualAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const editContentEntityMultilingual = async (
  data: Server.EditContentEntityByIdV2Input,
  onSuccess?: (response: string) => void | Promise<void>
) => {
  const res = await store.dispatch(editContentEntityMultilingualAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const setExpectedPublishDate = async (
  data: Server.SetContentEntityExpectedPublishDateInput,
  onSuccess?: (response: string) => void | Promise<void>
) => {
  const res = await store.dispatch(setExpectedPublishDateAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const clearContentEntityDetailsByIdMultilingual = async (
  onSuccess?: () => void | Promise<void>
) => {
  const res = store.dispatch(actions.clearDetailsByIdMultilingual());

  return handleDispatchResult(
    { ...res, meta: { requestStatus: 'fulfilled', arg: '', requestId: '' } },
    onSuccess
  );
};

export const getContentEntityBadge = async (
  id: string | undefined,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getContentEntityBadgeAsync(id));

  return handleDispatchResult(res, onSuccess);
};

export const setContentEntityBadge = async (
  data: SetContentEntityBadgeInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(setContentEntityBadgeAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const clearContentEntityBadge = async (
  onSuccess?: () => void | Promise<void>
) => {
  const res = store.dispatch(actions.clearContentEntityBadge());

  return handleDispatchResult(
    { ...res, meta: { requestStatus: 'fulfilled', arg: '', requestId: '' } },
    onSuccess
  );
};

export const getOnboardingRandomContentEntities = async (
  data: GetOnboardingRandomContentEntitiesInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    getOnboardingRandomContentEntitiesAsync(data)
  );

  return handleDispatchResult(res, onSuccess);
};

export const getOnboardingContentEntityDetailsById = async (
  id: string | undefined,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    getOnboardingContentEntityDetailsByIdAsync(id)
  );

  return handleDispatchResult(res, onSuccess);
};

export const getContentEntitySEOById = async (
  id: string | undefined,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getContentEntitySEOByIdAsync(id));

  return handleDispatchResult(res, onSuccess);
};

export const upsertContentEntitySEO = async (
  data: Server.UpsertContentEntitySeoCommand,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(upsertContentEntitySEOAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const clearData = async () => {
  store.dispatch(actions.clearData());
};

export const changeContentEntityArchiveStatus = async (
  data: Server.ArchiveContentEntityCommand,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(changeContentEntityArchiveStatusAsync(data));

  return handleDispatchResult(res, onSuccess);
};